import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import Spin from 'antd/lib/spin';
import {
  selectSetting,
  fetchSettingActions,
  selectSettingEditable,
  setSettingEditableAction,
  updateSettingActions,
} from '../ducks';
import { apiCallIds } from '../api';
import { SettingDetail } from '../components';

const mapStateToProps = (state, props) => ({
  setting: selectSetting(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_SETTING),
  isUpdating: selectIsInProgress(state, apiCallIds.UPDATE_SETTING),
  settingEditable: selectSettingEditable(state),
  settingId: props.params.settingId,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchSetting: fetchSettingActions.request,
      updateSetting: updateSettingActions.request,
      setSettingEditable: setSettingEditableAction,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class SettingDetailContainer extends Component {
  static propTypes = {
    setting: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    settingEditable: PropTypes.string.isRequired,
    settingId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { settingId, actions } = this.props;
    actions.fetchSetting({ settingId });
  }

  componentWillUnmount() {
    this.props.actions.setSettingEditable('');
  }

  onSubmit = settingData => {
    const { actions, settingId } = this.props;
    actions.updateSetting({ settingId, settingData });
  };

  onEdit = settingId => {
    this.props.actions.setSettingEditable(settingId);
  };

  render() {
    const { setting, isLoading, isUpdating, settingEditable } = this.props;

    if (!setting) {
      return (
        <Spin spinning={isLoading}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <Spin spinning={isLoading}>
        <SettingDetail
          isUpdating={isUpdating}
          setting={setting}
          settingEditable={settingEditable}
          onSubmit={this.onSubmit}
          onEdit={this.onEdit}
        />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/setting-management/containers/SettingDetailContainer.js